import { render, staticRenderFns } from "./FiscalPaymentTypeBadge.vue?vue&type=template&id=5b0042f6&scoped=true&"
import script from "./FiscalPaymentTypeBadge.vue?vue&type=script&lang=js&"
export * from "./FiscalPaymentTypeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0042f6",
  null
  
)

export default component.exports